interface GeoLocation {
  name: string;
  lat: number;
  lon: number;
  radius: number;
}

const LocationsSE: Record<string, GeoLocation> = {
  stockholm: {
    name: 'Stockholm',
    lat: 59.33,
    lon: 18.07,
    radius: 50,
  },
  goteborg: {
    name: 'Göteborg',
    lat: 57.71,
    lon: 11.97,
    radius: 50,
  },
  malmo: {
    name: 'Malmö',
    lat: 55.6,
    lon: 13.0,
    radius: 50,
  },
  uppsala: {
    name: 'Uppsala',
    lat: 59.86,
    lon: 17.64,
    radius: 50,
  },
  vasteras: {
    name: 'Västerås',
    lat: 59.61,
    lon: 16.54,
    radius: 50,
  },
  orebro: {
    name: 'Örebro',
    lat: 59.28,
    lon: 15.21,
    radius: 50,
  },
  norrkoping: {
    name: 'Norrköping',
    lat: 58.58,
    lon: 16.19,
    radius: 50,
  },
  linkoping: {
    name: 'Linköping',
    lat: 58.41,
    lon: 15.62,
    radius: 50,
  },
  helsingborg: {
    name: 'Helsingborg',
    lat: 56.05,
    lon: 12.69,
    radius: 50,
  },
  jonkoping: {
    name: 'Jönköping',
    lat: 57.78,
    lon: 14.16,
    radius: 50,
  },
  halmstad: {
    name: 'Halmstad',
    lat: 56.67,
    lon: 12.85,
    radius: 50,
  },
  vaxjo: {
    name: 'Växjö',
    lat: 56.87,
    lon: 14.81,
    radius: 50,
  },
  eskilstuna: {
    name: 'Eskilstuna',
    lat: 59.37,
    lon: 16.51,
    radius: 50,
  },
  kalmar: {
    name: 'Kalmar',
    lat: 56.66,
    lon: 16.36,
    radius: 50,
  },
  karlskrona: {
    name: 'Karlskrona',
    lat: 56.16,
    lon: 15.58,
    radius: 50,
  },
  karlstad: {
    name: 'Karlstad',
    lat: 59.38,
    lon: 13.49,
    radius: 50,
  },
  kristianstad: {
    name: 'Kristianstad',
    lat: 56.03,
    lon: 14.18,
    radius: 50,
  },
  sundsvall: {
    name: 'Sundsvall',
    lat: 62.39,
    lon: 17.31,
    radius: 50,
  },
  umea: {
    name: 'Umeå',
    lat: 63.83,
    lon: 20.25,
    radius: 50,
  },
  varberg: {
    name: 'Varberg',
    lat: 57.1,
    lon: 12.25,
    radius: 50,
  },
  boras: {
    name: 'Borås',
    lat: 57.72,
    lon: 12.93,
    radius: 50,
  },
  falkenberg: {
    name: 'Falkenberg',
    lat: 56.9,
    lon: 12.49,
    radius: 50,
  },
  gavle: {
    name: 'Gävle',
    lat: 60.67,
    lon: 17.14,
    radius: 50,
  },
  lulea: {
    name: 'Luleå',
    lat: 65.58,
    lon: 22.14,
    radius: 50,
  },
  lund: {
    name: 'Lund',
    lat: 55.7,
    lon: 13.19,
    radius: 50,
  },
  monsteras: {
    name: 'Mönsterås',
    lat: 57.04,
    lon: 16.44,
    radius: 50,
  },
  uddevalla: {
    name: 'Uddevalla',
    lat: 58.35,
    lon: 11.93,
    radius: 50,
  },
  vastervik: {
    name: 'Västervik',
    lat: 57.76,
    lon: 16.64,
    radius: 50,
  },
  ystad: {
    name: 'Ystad',
    lat: 55.43,
    lon: 13.83,
    radius: 50,
  },
  ostersund: {
    name: 'Östersund',
    lat: 63.17,
    lon: 14.64,
    radius: 50,
  },
  borlange: {
    name: 'Borlänge',
    lat: 60.49,
    lon: 15.42,
    radius: 50,
  },
  kiruna: {
    name: 'Kiruna',
    lat: 67.85,
    lon: 20.22,
    radius: 50,
  },
  nykoping: {
    name: 'Nyköping',
    lat: 58.75,
    lon: 17.01,
    radius: 50,
  },
  oskarshamn: {
    name: 'Oskarshamn',
    lat: 57.26,
    lon: 16.45,
    radius: 50,
  },
  sigtuna: {
    name: 'Sigtuna',
    lat: 59.61,
    lon: 17.72,
    radius: 50,
  },
  skelleftea: {
    name: 'Skellefteå',
    lat: 64.75,
    lon: 20.95,
    radius: 50,
  },
  skovde: {
    name: 'Skövde',
    lat: 58.39,
    lon: 13.84,
    radius: 50,
  },
  trollhattan: {
    name: 'Trollhättan',
    lat: 58.28,
    lon: 12.29,
    radius: 50,
  },
  alingsas: {
    name: 'Alingsås',
    lat: 57.93,
    lon: 12.53,
    radius: 50,
  },
  bastad: {
    name: 'Båstad',
    lat: 56.42,
    lon: 12.85,
    radius: 50,
  },
};

const LocationsNo: Record<string, GeoLocation> = {
  oslo: {
    name: 'Oslo',
    lat: 59.91,
    lon: 10.75,
    radius: 100,
  },
  bergen: {
    name: 'Bergen',
    lat: 60.39,
    lon: 5.32,
    radius: 100,
  },
  trondheim: {
    name: 'Trondheim',
    lat: 63.43,
    lon: 10.4,
    radius: 100,
  },
  stavanger: {
    name: 'Stavanger',
    lat: 58.97,
    lon: 5.73,
    radius: 100,
  },
  kristiansand: {
    name: 'Kristiansand',
    lat: 58.16,
    lon: 8.0,
    radius: 100,
  },
  fredrikstad: {
    name: 'Fredrikstad',
    lat: 59.21,
    lon: 10.95,
    radius: 100,
  },
  drammen: {
    name: 'Drammen',
    lat: 59.74,
    lon: 10.2,
    radius: 100,
  },
  skien: {
    name: 'Skien',
    lat: 59.2,
    lon: 9.6,
    radius: 100,
  },
  tromso: {
    name: 'Tromsø',
    lat: 69.65,
    lon: 18.96,
    radius: 100,
  },
  aalborg: {
    name: 'Ålesund',
    lat: 62.47,
    lon: 6.15,
    radius: 100,
  },
  moss: {
    name: 'Moss',
    lat: 59.43,
    lon: 10.66,
    radius: 100,
  },
  porsgrunn: {
    name: 'Porsgrunn',
    lat: 59.14,
    lon: 9.66,
    radius: 100,
  },
  bodo: {
    name: 'Bodø',
    lat: 67.28,
    lon: 14.4,
    radius: 100,
  },
  arendal: {
    name: 'Arendal',
    lat: 58.46,
    lon: 8.77,
    radius: 100,
  },
  hamar: {
    name: 'Hamar',
    lat: 60.79,
    lon: 11.07,
    radius: 100,
  },
  larvik: {
    name: 'Larvik',
    lat: 59.05,
    lon: 10.03,
    radius: 100,
  },
  halden: {
    name: 'Halden',
    lat: 59.12,
    lon: 11.38,
    radius: 100,
  },
  lillehammer: {
    name: 'Lillehammer',
    lat: 61.11,
    lon: 10.47,
    radius: 100,
  },
  molde: {
    name: 'Molde',
    lat: 62.73,
    lon: 7.16,
    radius: 100,
  },
  kongsberg: {
    name: 'Kongsberg',
    lat: 59.67,
    lon: 9.65,
    radius: 100,
  },
  harstad: {
    name: 'Harstad',
    lat: 68.8,
    lon: 16.54,
    radius: 100,
  },
  gjovik: {
    name: 'Gjøvik',
    lat: 60.8,
    lon: 10.7,
    radius: 100,
  },
  sarpsborg: {
    name: 'Sarpsborg',
    lat: 59.28,
    lon: 11.11,
    radius: 100,
  },
  sandefjord: {
    name: 'Sandefjord',
    lat: 59.13,
    lon: 10.22,
    radius: 100,
  },
  kristiansund: {
    name: 'Kristiansund',
    lat: 63.11,
    lon: 7.73,
    radius: 100,
  },
  tromsdalen: {
    name: 'Tromsdalen',
    lat: 69.64,
    lon: 19.01,
    radius: 100,
  },
  narvik: {
    name: 'Narvik',
    lat: 68.44,
    lon: 17.42,
    radius: 100,
  },
  steinkjer: {
    name: 'Steinkjer',
    lat: 64.01,
    lon: 11.49,
    radius: 100,
  },
  haugesund: {
    name: 'Haugesund',
    lat: 59.41,
    lon: 5.27,
    radius: 100,
  },
  alta: {
    name: 'Alta',
    lat: 69.97,
    lon: 23.27,
    radius: 100,
  },
};

const Locations: Record<string, GeoLocation> = {
  ...LocationsSE,
  ...LocationsNo,
};

export default Locations;
